<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='""' class="container-fluid product-page-en" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='"padding-top:80px;\n"' class="container-fluid  header-slider-top px-0 bg-territory" >
                <template #default>   </template>
                </m-div><m-div v-bind='{...{},...{}}' :style='"width:94%;\nposition:relative;\n"' class="container-fluid P-0 my-5 product-slider-wrapper-en" >
                <template #default>   <m-product-slider-501 v-bind='{...{"offerType":"number","offerStatus":true,"title":"","productCategories":["Mushroom-Compost-and-Fertilizer"],"productBrands":null,"waitForCategory":false,"waitForBrand":false,"categoryColumn":"slug","brandColumn":"slug","productCardLink":false,"productCardLinkTarget":"_self","activeLatestFilter":true,"activeCategoryFilter":true,"productCardName":"mProductCard207","showKeywords":false,"showDefaultSlideItem":false,"swiperPerViewSM":2,"swiperPerViewMD":3,"swiperPerViewLG":6,"autoPlay":false,"autoPlayDuration":1000},...{}}' :style='""' class="m-product-wrapper-middle" >
                <template #default>   </template>
                </m-product-slider-501><m-div v-bind='{...{},...{}}' :style='"    position: absolute;\n    border: 1px solid var(--secondary);\n    top: 6.8%;\n    bottom: 5%;\n    left: 5.1%;\n    right: 5.1%;\n    border-radius: 1rem;"' class="text-center" >
                <template #default>   <m-p v-bind='{...{},...{}}' :style='"font-size: 1rem;\ntranslate: 0 -45px;\n"' class="text-center  d-inline-block p-3 bg-background  mt-3" >
                <template #default>Mushroom Compost and Fertilizer
   </template>
                </m-p></template>
                </m-div></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="my-5" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="text-center" >
                <template #default>   <m-h2 v-bind='{...{},...{}}' :style='"border-bottom:2px solid black;\nfont-size: 20px;\ndirection: ltr;"' class="mb-5 text-primary d-inline-block pb-3" >
                <template #default>To receive advice and contact, please complete the form below.   </template>
                </m-h2></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="justify-content-center row mx-auto form-wrapper-en" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-lg-6 mx-auto" >
                <template #default>   <m-form-single-1 v-bind='{...{"itemClass":"col-lg-12 mb-4","formId":3,"redirectToDashboard":false,"redirectDirectLink":""},...{}}' :style='""' class="" ></m-form-single-1></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mProductSlider501 from '@moeinmdn/miw-alpha-components/src/package/Product/ProductSlider/ProductSlider501'; import mP from '@moeinmdn/miw-alpha-components/src/package/Tags/P'; import mH2 from '@moeinmdn/miw-alpha-components/src/package/Tags/H2'; import mFormSingle1 from '@moeinmdn/miw-alpha-components/src/package/Form/FormSingle/FormSingle1';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mProductSlider501,mP,mH2,mFormSingle1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
